import React from "react";
import { Icon, theme } from "uikit";
import Root from "./components/Root";

const DeleteButton: React.FC<DeleteButton.Props> = ({ onClick }) => (
	<Root onClick={onClick}>
		<Icon id="trash2" size={16} colors={[theme.colors.secondary]} />
	</Root>
);

declare namespace DeleteButton {
	interface Props {
		onClick: () => void;
	}
}

export default DeleteButton;
